import template from './faq.html';
import controller from './faq.controller';

export const faqComponent = {
  restrict: 'E',
  bindings: {

  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/faq/faq.component.js